export default __webpack_public_path__ + "static/media/387.5ff8d4a5.png";